import SlashCommandChip from '@/components/SlashCommandChip'
import { NodeViewRendererProps, NodeViewWrapper } from '@tiptap/react'

export default function SlashCommandNode(props: NodeViewRendererProps) {
  return (
    <NodeViewWrapper className="inline">
      <SlashCommandChip name={props.node.attrs.command} npub={props.node.attrs.npub} />
    </NodeViewWrapper>
  )
}
